import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-hotelandrestaurents',
  templateUrl: './hotelandrestaurents.component.html',
  styleUrls: ['./hotelandrestaurents.component.scss']
})
export class HotelandrestaurentsComponent implements OnInit {
  safeURL; //youTube Video URL //

  constructor(private meta: Meta, private title: Title, private _sanitizer: DomSanitizer, private metaService: MetaServiceService) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: "A satisfied customer is a happy customer capable of turning into your Hotel or Restaurant’s survey branding ambassador." },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'Restaurant Satisfaction survey , Hotel feedback survey , Restaurant customer satisfaction survey  , Happy customers  , Restaurant survey  , restaurant customer questionnaire , hotel customer satisfaction questionnaire , Hotel guest satisfaction survey , Restaurant customer satisfaction survey' }
    ]);

    this.setTitle('Hotel and Restaurant satisfaction survey | Restaurant customer satisfaction survey');
    // End SEO Meta Description

    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/zG1vmrrSxng?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
    // End You Tube Video Description
  }


  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description


  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();
  }


  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
